<input type="checkbox" id="findMultiple" class="toolbarField" />
<label for="findMultiple" class="toolbarLabel" data-l10n-id="pdfjs-find-multiple-checkbox-label"
  title="multiple queries separated by space"> Multiple words
</label>